import { graphql } from '@/generated/gql';

export const SOURCING_CASE_SUPPLIER_FILE_ATTACHMENTS_QUERY = graphql(/* GraphQL */ `
  query SourcingCaseSupplierFileAttachments(
    $sourcingCaseId: UUID!
    $parents: [TsrctAttachmentParentInput!]!
    $filter: TsrctAttachmentFilterInput
  ) {
    tesseract {
      attachments(parents: $parents, filter: $filter) {
        ...FileAttachment
      }
      sourcingCase(id: $sourcingCaseId) {
        id
        status
      }
    }
  }
`);
